import { styled } from 'styled-components';
import themeHelper from '../../utils/themeHelper';

export const ModalContent = styled.div`
  min-width: 85vw;
`;

export const Container = styled.div`
  padding-top: ${themeHelper.spacing(0.5)};
`;
